import React, { useState, Dispatch, SetStateAction } from 'react';

import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import axios from '../../utils/axios.utils';
import Button from '@mui/material/Button';

interface CreatorToggleProps {
  label: string;
  controller: string;
  field: string;
  otherParams?: any;
  afterCreate: () => void;
}

const CreatorToggle: React.FC<CreatorToggleProps> = (props) => {
  const { otherParams, label, controller, field, afterCreate } = props;

  let [isEditing, setIsEditing] = useState(false);
  let [inputValue, setInputValue] = useState('');
  let [errorMessage, setErrorMessage] = useState('');

  const createRecord = async () => {
    try {
      const response: any = await axios.post(`/${controller}`, {
        [field]: inputValue,
        ...otherParams,
      });
      setIsEditing(false);
      afterCreate();
    } catch (error: any) {
      setErrorMessage(error.response?.data || 'An error occurred');
    }
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      createRecord();
    }
  };

  return isEditing ? (
    <Grid container spacing={2} alignItems="center" onKeyDown={handleKeyPress}>
      <Grid item xs>
        <TextField
          type="text"
          placeholder={`Add ${label}`}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          fullWidth
          autoFocus
          sx={{
            '& .MuiOutlinedInput-root': {
              '&:focus-within': {
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#72a295',
                  borderWidth: '2px',
                },
              },
            },
          }}
        />
      </Grid>
      <Grid item>
        <Grid container spacing={1}>
          <Grid item>
            <Button
              variant="contained"
              onClick={createRecord}
              sx={{
                backgroundColor: '#72a295',
                '&:hover': {
                  backgroundColor: '#649789',
                },
                minWidth: 'auto',
                padding: '8px',
              }}
            >
              <SaveIcon fontSize="small" />
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              onClick={() => {
                setIsEditing(false);
              }}
              sx={{
                minWidth: 'auto',
                padding: '8px',
                borderColor: 'grey.400',
                color: 'text.primary',
                '&:hover': {
                  borderColor: 'grey.400',
                  backgroundColor: 'grey.50',
                },
              }}
            >
              <CloseIcon fontSize="small" />
            </Button>
          </Grid>
        </Grid>
      </Grid>
      {errorMessage && (
        <Grid item xs={12}>
          <Typography variant="body2" color="error">
            {errorMessage}
          </Typography>
        </Grid>
      )}
    </Grid>
  ) : (
    <Grid container justifyContent="flex-end">
      <Grid item>
        <Button
          variant="contained"
          onClick={() => {
            setIsEditing(true);
          }}
          sx={{
            backgroundColor: '#72a295',
            color: 'white',
            height: '40px',
            fontSize: '14px',
            fontWeight: 500,
            padding: '8px 16px',
            marginTop: '16px',
            '&:hover': {
              backgroundColor: '#649789',
              color: 'grey.800',
            },
          }}
        >
          + Create {label}
        </Button>
      </Grid>
    </Grid>
  );
};

export default CreatorToggle;
